const textButton = {
    types: {
        primary: {
            textColor: 'PRIMARY_600',
            underlineColor: 'PRIMARY_400',
            hoverTextColor: 'PRIMARY_700',
            hoverUnderlineColor: 'PRIMARY_700',
            disabledTextColor: 'PRIMARY_400',
            disabledUnderlineColor: 'PRIMARY_400',
        },
        destructive: {
            textColor: 'RED_600',
            underlineColor: 'RED_600',
            hoverTextColor: 'RED_700',
            hoverUnderlineColor: 'RED_700',
            disabledTextColor: 'RED_300',
            disabledUnderlineColor: 'RED_300',
        },
        reversed: {
            textColor: 'SNOW_100',
            underlineColor: 'SNOW_A600',
            hoverTextColor: 'INK_300',
            hoverUnderlineColor: 'INK_700',
            disabledTextColor: 'PRIMARY_A400',
            disabledUnderlineColor: 'PRIMARY_A200',
        },
        secondary: {
            textColor: 'INK_500',
            underlineColor: 'INK_300',
            hoverTextColor: 'INK_600',
            hoverUnderlineColor: 'INK_500',
            disabledTextColor: 'INK_300',
            disabledUnderlineColor: 'INK_300',
        },
        dark: {
            textColor: 'INK_800',
            underlineColor: 'INK_500',
            hoverTextColor: 'INK_800',
            hoverUnderlineColor: 'INK_800',
            disabledTextColor: 'INK_300',
            disabledUnderlineColor: 'INK_300',
        },
    },
};
export default textButton;
//# sourceMappingURL=textButtons.js.map